// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__14y-m","filesListContainer":"PosDisputesFiles_filesListContainer__1qDB4","filesButton":"PosDisputesFiles_filesButton__2AOpP"};